import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ProyectoService} from '../../../services/proyecto.service';
import {EmpresaService} from '../../../services/empresa.service';
import {proyecto} from '../../../models/proyecto';
import {user} from '../../../models/user';
import {empresa} from '../../../models/empresa';
import {UserService} from '../../../services/user.service';
import {Localiser} from "../../../services/localiser";

@Component({
  selector: 'app-new-proyecto',
  templateUrl: './new-proyecto.component.html',
  styleUrls: ['./new-proyecto.component.css']
})
export class NewProyectoComponent implements OnInit {

  nombre: string;
  coordenadas: string;

  proyecto: proyecto;
  usuarios: user[];
  selectUsuarios: boolean = false;

  constructor(public dialogRef: MatDialogRef<NewProyectoComponent>, @Inject(MAT_DIALOG_DATA) public data: {empresa: empresa},
              private proyectoService: ProyectoService, private userService: UserService, public localiser: Localiser) { }

  ngOnInit(): void {
    this.selectUsuarios = false;
  }

  newProyecto() {
    let proyectoRequest: proyecto = {
      idProyecto: "ID",
      idEmpresa: this.data.empresa.idEmpresa,
      nombre: this.nombre,
      coordenadas: this.coordenadas
    }
    this.proyectoService.new(proyectoRequest).subscribe(result => {
      this.proyecto = <proyecto>JSON.parse(result);
      console.log(this.proyecto);
      this.userService.getByIdEmpresa(this.data.empresa.idEmpresa).subscribe(result => {
        this.usuarios = <Array<user>> result;
        this.selectUsuarios = true;
      })
    });
  }

  change(idUsuario, check) {
    this.userService.changeProyecto(idUsuario, this.proyecto.idProyecto, check);
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
